(function () {
  function initImportAudioModal() {
    var uploadArea = $('#uploadArea');
    if (!uploadArea.length) {
      return;
    }

    var fileInput = $('#audio_zip');
    var selectedFile = $('.selected-file');
    var fileName = $('.file-name');
    var form = $('form.validate');
    var submitButton = $('input[type="submit"]');

    $('.upload-content').on('click', function (e) {
      e.preventDefault();
      fileInput.trigger('click');
    });

    submitButton.on('click', function (e) {
      if (!fileInput[0].files.length) {
        e.preventDefault();
        alert('Please select a ZIP file');
        return false;
      }

      // Submit the form normally — the controller redirects to a status page
      submitButton.prop('disabled', true);
      submitButton.val('Processing...');
      form[0].submit();
    });

    fileInput.on('change', function () {
      if (this.files.length) {
        updateFileName(this.files[0]);
      }
    });

    uploadArea.on('dragover dragenter', function (e) {
      e.preventDefault();
      $(this).addClass('dragover');
    });

    uploadArea.on('dragleave dragend drop', function (e) {
      e.preventDefault();
      $(this).removeClass('dragover');
    });

    uploadArea.on('drop', function (e) {
      e.preventDefault();
      var files = e.originalEvent.dataTransfer.files;
      if (files.length) {
        fileInput[0].files = files;
        updateFileName(files[0]);
      }
    });

    function updateFileName(file) {
      fileName.text(file.name);
      selectedFile.show();
    }
  }

  $(document).on('turbolinks:load', initImportAudioModal);
  $(document).on('ark:modal:loaded', initImportAudioModal);
})();
